import * as React from "react";
import { cn } from "@/lib/utils";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = "text", ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        "flex h-11 w-full rounded-md border bg-[var(--talenta-surface-elevated)] px-3 py-2 text-sm",
        "placeholder:text-[var(--talenta-text-muted)]",
        "focus-visible:outline-2 focus-visible:outline-offset-2",
        "disabled:opacity-50 disabled:pointer-events-none",
        className,
      )}
      style={{
        borderColor: "var(--talenta-border-strong)",
        color: "var(--talenta-text)",
      }}
      {...props}
    />
  ),
);
Input.displayName = "Input";
